const getDefaultApiUrl = () => {
    const currentUrl = new URL(window.location.origin);

    if (currentUrl.hostname.startsWith('dev.')) {
        currentUrl.hostname = currentUrl.hostname.replace(/^dev\./, '');
    }

    return currentUrl.origin;
};

export const API_URL = process.env.VUE_APP_API_URL || getDefaultApiUrl();
